<template>
  <div>
    <div class="teq-container">
      <div class="input-container">
        <input
          type="text"
          :placeholder="placeholderSearch"
          class="input_search"
          v-model="query"
          @input="getSearchResultAutoComplete"
          @keyup.enter="selectResult"
        >
        <div
          class="btn-close"
          v-if="query.length > 0"
        >
          <svg
            class="icon icon-close-social"
            @click="reset()"
          >
            <use xlink:href="#icon-close-social"></use>
          </svg>
        </div>
      </div>
    </div>

    <search-auto-complete
      v-if="!list && results"
      :results="results"
      :query="query"
      :text-cta="textCta"
      :no-resu="noResuAutoComplete"
    />

    <div class="filter-total">
      <div class="total">
        <!-- eslint-disable-next-line -->
        <span class="result-nb"
        >{{ totalResult }}
          {{ totalResult <= 1 ? resultTextSingular : resultTextPlural }} </span><span class="result-txt">{{ searchFor }} </span><span class="result-word">{{ query }}</span>
      </div>
      <div
        class="filters-container"
        v-if="filter !== null"
      >
        <filter-by

          v-if="!noResuAutoComplete"
          :query="query"
          :base-url="baseUrl"
          :filter-list="filter[0]"
          @list="list = $event"
          @totalResult="totalResult = $event"
          @totalPage="totalPages = $event"
          @noResult="noResu = $event"
          @pageNum="pagenum = $event"
          @optionSelected="filterGlobal = $event"
          :filter-text="filterGlobalText"
          :filter-select="filterGlobal"
        />
        <filter-by
          v-if="!noResuAutoComplete"
          :query="query"
          :base-url="baseUrl"
          :filter-list="filter[1]"
          @list="list = $event"
          @totalResult="totalResult = $event"
          @totalPage="totalPages = $event"
          @noResult="noResu = $event"
          @pageNum="pagenum = $event"
          @optionSelected="filterCtp = $event"
          :filter-text="filterCtpText"
          :filter-select="filterCtp"
        />
        <filter-by
          v-if="!noResuAutoComplete && filterCtp === 'medias'"
          :query="query"
          :base-url="baseUrl"
          :filter-list="filter[2]"
          @list="list = $event"
          @totalResult="totalResult = $event"
          @totalPage="totalPages = $event"
          @noResult="noResu = $event"
          @pageNum="pagenum = $event"
          @optionSelected="filterMedia = $event"
          :filter-text="filterMediaText"
          :filter-select="filterMedia"
        />
      </div>
    </div>

    <div
      class="noresult"
      v-if="(list == null || list.length == 0) && noResu == true"
    >
      0 {{ resultTextSingular }}
    </div>

    <div
      class="container-result"
      v-if="list"
    >
      <template v-for="(item, index) in list">
        <search-item
          :item="item"
          :key="index"
          :asset-url="assetsUrl"
          v-if="typeof item == 'object'"
          :trad="tradData"
        />
      </template>
    </div>

    <div
      class="btn"
      @click="loadMore()"
      v-if="list && pagenum < totalPages"
    >
      {{ seeMore }}
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import SearchAutoComplete from "./SearchAutocomplete";
import SearchItem from "./SearchItem";
import FilterBy from "./FilterBy";
import { objectExpression } from "@babel/types";

export default {
  components: {
    SearchAutoComplete,
    SearchItem,
    FilterBy
  },
  data() {
    return {
      query: "",
      results: null,
      list: null,
      totalPages: null,
      totalResult: null,
      pagenum: 1,
      noResu: false,
      textCta: "",
      noResuAutoComplete: null,
      filterGlobal: null,
      filterCtp: null,
      filterMedia: null,
        timeout: null,
      test: null,
    lang: document.documentElement.lang,
      filter: null,
    };
  },
  props: {
    baseUrl: {
      type: String,
      required: true
    },
    placeholderSearch: {
      type: String,
      required: true
    },
    noResult: {
      type: String,
      required: true
    },
    assetsUrl: {
      type: String,
      required: true
      },
      searchFor: {
        type: String,
      required: true
      },
    resultTextSingular: {
      type: String,
      required: true
    },
    resultTextPlural: {
      type: String,
      required: true
    },
    seeMore: {
      type: String,
      required: true
    },
    filterGlobalText: {
      type: String,
      required: true
    },
    filterCtpText: {
      type: String,
      required: true
    },
    filterMediaText: {
      type: String,
      required: true
    },
    nbQueryLimitMobile: {
      type: String,
      required: true
    },
    nbQueryLimitDesktop: {
      type: String,
      required: true
    },
    seeMoreAutocomplete: {
      type: String,
      required: true
    },
    launchSearchAutocomplete: {
      type: String,
      required: true
    },
    tradData: {
      type: [Array, Object],
      required: true
    }
  },

  watch: {
    filterGlobal() {
      this.optionSelected();
    },
    filterCtp() {
      this.optionSelected();
    },
    filterMedia() {
      this.optionSelected();
    }
  },

  methods: {
    /* eslint-disable */
    // route : url-du-site/wp-json/teq-api/v1/search?term={string}&page={int}&filter_global={string}&filter_ctp={string}&filter_media={string}&lang_current={string}
    async optionSelected() {
      const ApiUrL = `${this.baseUrl}search?term=`;
      try {
        if (this.query) {
          const data = await axios.get(
            `${ApiUrL + this.query}&page=1&filter_global=${
              this.filterGlobal
            }&filter_ctp=${this.filterCtp}&filter_media=${
              this.filterMedia
            }&lang_current=${this.lang}`
          );

            this.list = data.data;
          this.filter = JSON.parse(data.data.filter_formated)
          if (this.list.length == 0) this.noResu = true;
          this.totalPages = data.data.totalpages;

          if (data.data.total > 0) {
            this.totalResult = data.data.total;
          } else {
            this.totalResult = 0;
          }
        }
      } catch (error) {
        return error;
      }
    },

    async getSearchResultAutoComplete() {
      if (this.query.length < 3) {
        this.noResu = false;
      }
      if (this.query.length >= 3) {
        document.querySelector(".filter-total").classList.remove("active");
      }
      this.filterGlobal = "";
      this.filterCtp = "";
      this.filterMedia = "";
      await this.requestAutoSearh();
    },

    async selectResult() {
      if (this.query.length < 3) {
        this.noResu = true;
        return;
      }
      const ApiUrL = `${this.baseUrl}search?term=`;
      try {
        if (
          this.filterGlobal !== "" ||
          this.filterCtp !== "" ||
          this.filterMedia !== ""
        ) {
          const data = await axios.get(
            `${ApiUrL + this.query}&page=1&filter_global=${
              this.filterGlobal
            }&filter_ctp=${this.filterCtp}&filter_media=${
              this.filterMedia
            }&lang_current=${this.lang}`
          );
            this.list = data.data;
          this.filter = JSON.parse(data.data.filter_formated)
          if (this.list.length == 0) this.noResu = true;
          this.totalPages = data.data.totalpages;
          if (data.data.total > 0) {
            this.totalResult = data.data.total;
            document.querySelector(".filter-total").classList.add("active");
          } else {
            this.totalResult = 0;
            document.querySelector(".filter-total").classList.remove("active");
          }
        } else {
          const data = await axios.get(
            `${ApiUrL + this.query}&page=1` + `&lang_current=${this.lang}`
          );
            this.list = data.data;
          this.filter = JSON.parse(data.data.filter_formated)
          if (this.list.length == 0) this.noResu = true;
          this.totalPages = data.data.totalpages;
          if (data.data.total > 0) {
            this.totalResult = data.data.total;
            document.querySelector(".filter-total").classList.add("active");
          } else {
            this.totalResult = 0;
            document.querySelector(".filter-total").classList.remove("active");
          }
        }

        
      } catch (error) {
        return error;
      }
    },

    async loadMore() {
      const ApiUrL = `${this.baseUrl}search?term=`;
      const newPage = this.pagenum + 1;
      try {
        if (
          this.filterGlobal !== "" ||
          this.filterCtp !== "" ||
          this.filterMedia !== ""
        ) {
          const data = await axios.get(
            `${ApiUrL + this.query}&page=${newPage}&filter_global=${
              this.filterGlobal
            }&filter_ctp=${this.filterCtp}&filter_media=${
              this.filterMedia
            }&lang_current=${this.lang}`
          );
          const newData = data.data;
          delete newData.total;
          delete newData.totalpages;
          this.list = Object.values(this.list).concat(Object.values(newData));
        } else {
          const data = await axios.get(
            `${ApiUrL + this.query}&page=${newPage}&lang_current=${this.lang}`
          );
          const newData = data.data;
          delete newData.total;
          delete newData.totalpages;
          this.list = Object.values(this.list).concat(Object.values(newData));
        }

        this.pagenum = newPage;
      } catch (error) {
        return error;
      }
    },
   
    reset() {
      this.query = "";
      this.results = null;
      this.list = null;
      this.totalPages = null;
      this.totalResult = null;
      this.pagenum = 1;
      this.noResu = false;
      this.filterGlobal = "";
      this.filterCtp = "";
      this.filterMedia = "";
      this.textCta = "";
      document.querySelector(".filter-total").classList.remove("active");
    },

    async requestAutoSearh() {
      const ApiUrl = `${this.baseUrl}autocompletesearch?term=`;
      try {
        let data = "";
        if (this.query.length >= 3) {
          if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
              navigator.userAgent
            )
          ) {
            data = await axios.get(
              `${ApiUrl + this.query}&lang_current=${this.lang}&query_limit=${
                this.nbQueryLimitMobile
              }`
            );
            this.minDataLength = 3;
          } else {
            data = await axios.get(
              `${ApiUrl + this.query}&lang_current=${this.lang}&query_limit=${
                this.nbQueryLimitDesktop
              }`
            );
            this.minDataLength = 5;
          }
          this.test = data.data
          this.results = data.data;

          // Define Autocomplete CTA text depending on device and size of results
          if (data.data.total > this.minDataLength) {
            this.textCta = this.seeMoreAutocomplete;
          } else {
            this.textCta = this.launchSearchAutocomplete;
          }

          this.noResu = this.results.length === 0;
          this.noResuAutoComplete = !data.data.total;

          this.list = null;
        }
      } catch (error) {
        return error;
      }
    }
  }
};
</script>
